import { IProductDetail } from '@/api/types/public';
import MagicJump, { JumpTarget } from '@/components/MagicJump';
import { setSession } from '@/utils/tools';
import Image from '@/components/Image';
import React from 'react';

interface ActivityModuleProps {
  item: NonNullable<IProductDetail['commodity_details_label']>[0];
  SDProductDetailsPageBtnClick?: (btnName: string) => void;
}

const ActivityModule: React.FC<ActivityModuleProps> = ({ item, SDProductDetailsPageBtnClick }) => {
  // 只有 type=activity 且 scene=1 时才渲染
  if (item.type !== 'activity' || item.scene !== 1 || item.status !== 1) {
    return null;
  }

  // 如果没有图片，不渲染
  if (!item.image) {
    return null;
  }

  // 构建跳转目标对象
  const jumpTarget: JumpTarget = {
    jump_type: item.jump_type,
    Jump_target: item.Jump_target,
  };

  const handleJumpClick = () => {
    // 触发埋点
    if (item.button_buried_name) {
      setSession('zl_goodsListEnterPageScene', '商详页活动标签');
      SDProductDetailsPageBtnClick?.(item.button_buried_name);
    } else {
      SDProductDetailsPageBtnClick?.('Activity');
    }
  };

  return (
    <MagicJump
      item={jumpTarget}
      onJumpClick={handleJumpClick}
      className="cursor-pointer mx-[3px] my-[1px]"
    >
      <Image
        className="rounded-[4px] h-[20px] w-auto"
        src={item.image}
        alt="Activity"
        height={20}
        width={0}
        style={{ width: 'auto' }}
      />
    </MagicJump>
  );
};

export default ActivityModule;
